import { defineMessages } from "react-intl";

import {
	ovszSignedMessages,
	validator
} from "lib/build/forms/ktx/basic-registration-data/patientStatementOfConsentOvsz";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	patientStatementOfConsentOvsz: {
		id: "ktx.form.patient_statement_of_consent_ovsz",
		defaultMessage: "Páciens beleegyező nyilatkozat (OVSZ)"
	},
	ovszSigned: {
		id: "ktx.form.patient_statement_of_consent_ovsz.signed",
		defaultMessage:
			"Kérjük az űrlaphoz töltse fel mellékletként az aláírt nyilatkozatot beszkennelt vagy lefotózott formában és a nyilatkozatot papír alapon őrizze meg a beküldő intézmény."
	}
});

const fields: { [key: string]: FieldData } = {
	ovszSigned: {
		type: "field",
		path: ["ovszSigned"],
		label: messages.ovszSigned,
		errorMessages: genericErrorMessages,
		input: { type: "radio-group", props: { labels: ovszSignedMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.ovszSigned }] }]
};

export const node: LeafNode = {
	id: "ktx_patientStatementOfConsentOvsz",
	value: {
		schemaId: "patientStatementOfConsentOvsz",
		title: messages.patientStatementOfConsentOvsz,
		validator,
		fieldset
	}
};
